export enum AppTransactionType {
  Deposit,
  Withdraw,
}
